module.exports = __webpack_public_path__ + "img/cpsc-logo.1a2d14ed.png";